import { hexToRgb } from '@propertypal/shared/src/utils/colour';
import styled from 'styled-components';
import { SmallHeading, Text } from '../typography';

const COLUMN_GAP = 40;
const COL_3_BP = 1180;
const COL_2_BP = 800;
const col3Bp = `max-width: ${COL_3_BP}px`;
const col2Bp = `max-width: ${COL_2_BP}px`;

export const FaqSection = styled.div`
  padding: 40px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.white};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  img {
    height: 65px;
    margin-bottom: 25px;
  }

  ${SmallHeading} {
    color: ${({ theme }) => theme.textDark};
  }

  ${Text} {
    white-space: pre-line;
  }
`;

export const FaqSections = styled.div`
  display: flex;
  gap: 30px ${COLUMN_GAP}px;
  flex-wrap: wrap;
  justify-content: center;

  ${FaqSection} {
    flex-basis: calc((100% / 3) - ${COLUMN_GAP / 1.5}px);

    @media (${col3Bp}) {
      flex-basis: calc((100% / 2) - ${COLUMN_GAP / 2}px);
    }

    @media (${col2Bp}) {
      flex-basis: 100%;
      max-width: 400px;
      width: 100%;
    }
  }
`;

export const ButtonLink = styled.button`
  background-color: ${({ theme }) => theme.primary};
  border-radius: 4px;
  padding: 16px 10px;
  color: ${({ theme }) => theme.white};
  font-weight: bold;
  font-size: 16px;
  width: 240px;
  transition: background-color 0.4s ease 0s;

  &:hover {
    background-color: ${({ theme }) => hexToRgb(theme.primary, 1, -55)};
  }
`;
